<template>
  <div v-if="breadcrumbLinks.length" class="sa-breadcrumbs">
    <div class="row">
      <div class="col-12">
        <span
          v-for="(value,index) in breadcrumbLinks"
          :key="index"
        >
          <span v-if="index < breadcrumbLinks.length - 1">
            <router-link :to="value.url">{{ value.text }}</router-link> >
          </span>
          <span v-else>
            {{ value.text }}
          </span>
        </span>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Breadcrumbs',
  props: {
    breadcrumbLinks: {
      type: Array,
      default() {
        return []
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/vendor/_bootstrap-setup";
@import "../styles/environment/_variables";


.sa-breadcrumbs {
  font-size: $font-size-small;
  div, p {
    font-size: $font-size-small;
  }
}

</style>
